import { useState } from "react";
import { tronquerTexteMaths } from "../../utils/tronquerTexteMaths";
import MathText from "../VueQuestion/MathText";

export const TruncatedTextWithTooltip = ({
  text,
  maxLength = 100,
  className = "",
  renderFunction = null
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!text) return null;

  // Troncature sûre pour le LaTeX (programme 2025) : couper au milieu d'un
  // segment $...$ afficherait un dollar orphelin brut dans l'en-tête.
  const { truncated: displayText, isTruncated: shouldTruncate } = tronquerTexteMaths(text, maxLength);
  
  // Sans renderFunction fourni, le défaut rend quand même le LaTeX $...$
  // (descriptions d'attendus du programme 2025).
  const renderContent = (content) => {
    return renderFunction ? renderFunction(content) : <MathText>{content}</MathText>;
  };

  return (
    <div className="relative inline-block">
      <span
        className={`${className} ${shouldTruncate ? 'cursor-help border-b border-dotted border-current opacity-90 hover:opacity-100 transition-all duration-200' : ''}`}
        onMouseEnter={() => shouldTruncate && setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        title=""
      >
        {renderContent(displayText)}
      </span>

      {showTooltip && shouldTruncate && (
        <div 
          className="fixed z-[9999] pointer-events-none"
          style={{
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          {/* Backdrop/overlay */}
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm"></div>
          
          {/* Dialog container */}
          <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-[90vw] max-h-[80vh] overflow-hidden animate-in zoom-in-95 fade-in duration-200">
            
            {/* Header du dialog */}
            <div className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white p-4 flex items-center gap-3">
              <div className="w-2 h-2 bg-white/70 rounded-full"></div>
              <div className="w-2 h-2 bg-white/70 rounded-full"></div>
              <div className="w-2 h-2 bg-white/70 rounded-full"></div>
              <h3 className="ml-2 font-semibold text-lg">📄 Contenu complet</h3>
            </div>
            
            {/* Contenu */}
            <div className="p-6 overflow-y-auto max-h-[60vh]">
              <div className="prose prose-sm max-w-none">
                <div className="text-gray-800 leading-relaxed whitespace-pre-wrap break-words">
                  {renderContent(text)}
                </div>
              </div>
            </div>
            
            {/* Footer avec stats */}
            <div className="bg-gray-50 px-6 py-3 border-t border-gray-100 flex justify-between items-center text-xs text-gray-500">
              <div className="flex gap-4">
                
              </div>
              <div className="text-blue-500 font-medium">
                💡 Survolez pour fermer
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};